import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";

/* ============ STYLES (self-contained) ============ */
const CSS = `
.hm-page { padding: 4px 0 40px; color: #1f2937; }
.hm-page * { box-sizing: border-box; }
.hm-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; margin-bottom: 18px; flex-wrap: wrap; }
.hm-head h2 { margin: 4px 0; font-size: 24px; display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.hm-head p { margin: 0; color: #6b7280; font-size: 14px; }
.hm-eyebrow { font-size: 11px; letter-spacing: .12em; color: #2563eb; font-weight: 700; }
.hm-btn { border: 1px solid #d1d5db; background: #fff; color: #111827; padding: 9px 16px; border-radius: 8px; cursor: pointer; font-size: 14px; font-weight: 600; }
.hm-btn:hover:not(:disabled) { background: #f3f4f6; }
.hm-btn:disabled { opacity: .55; cursor: not-allowed; }
.hm-btn.primary { background: #2563eb; border-color: #2563eb; color: #fff; }
.hm-btn.primary:hover:not(:disabled) { background: #1d4ed8; }
.hm-btn.danger { color: #b91c1c; border-color: #fecaca; }
.hm-btn.danger:hover:not(:disabled) { background: #fef2f2; }
.hm-btn.sm { padding: 6px 12px; font-size: 13px; }
.hm-link { background: none; border: 0; color: #2563eb; cursor: pointer; font-weight: 600; padding: 0; font-size: 14px; }
.hm-notice { padding: 12px 16px; border-radius: 8px; margin-bottom: 14px; font-size: 14px; }
.hm-notice.success { background: #ecfdf5; color: #065f46; border: 1px solid #a7f3d0; }
.hm-notice.error { background: #fef2f2; color: #991b1b; border: 1px solid #fecaca; }
.hm-notice.info { background: #eff6ff; color: #1e40af; border: 1px solid #bfdbfe; }
.hm-toolbar { display: flex; gap: 10px; margin-bottom: 14px; flex-wrap: wrap; }
.hm-toolbar .hm-input:first-child { flex: 1; min-width: 220px; }
.hm-input { width: 100%; padding: 10px 12px; border: 1px solid #d1d5db; border-radius: 8px; font-size: 14px; background: #fff; color: #111827; font-family: inherit; }
.hm-input:focus { outline: none; border-color: #2563eb; box-shadow: 0 0 0 3px rgba(37,99,235,.12); }
.hm-toolbar .hm-input { width: auto; }
.hm-state { background: #fff; border: 1px dashed #d1d5db; border-radius: 12px; padding: 40px 20px; text-align: center; color: #6b7280; }
.hm-state.err { color: #b91c1c; border-color: #fecaca; }
.hm-state h3 { margin: 8px 0 4px; color: #111827; }
.hm-empty-icon { font-size: 40px; color: #9ca3af; }
.hm-table-wrap { background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; overflow-x: auto; }
.hm-table { width: 100%; border-collapse: collapse; min-width: 900px; }
.hm-table th { text-align: left; font-size: 12px; text-transform: uppercase; letter-spacing: .04em; color: #6b7280; padding: 12px 14px; background: #f9fafb; border-bottom: 1px solid #e5e7eb; }
.hm-table td { padding: 12px 14px; border-bottom: 1px solid #f1f5f9; font-size: 14px; vertical-align: middle; }
.hm-table tr:last-child td { border-bottom: 0; }
.hm-table .r { text-align: right; }
.hm-cell-main { display: flex; align-items: center; gap: 12px; }
.hm-cell-main strong { display: block; }
.hm-cell-main small { color: #6b7280; }
.hm-thumb { width: 56px; height: 44px; object-fit: cover; border-radius: 8px; background: #e5e7eb; }
.hm-noimg { width: 56px; height: 44px; display: grid; place-items: center; background: #f3f4f6; color: #9ca3af; font-size: 10px; border-radius: 8px; }
.hm-actions { display: inline-flex; gap: 6px; flex-wrap: wrap; }
.hm-badge { display: inline-block; padding: 3px 10px; border-radius: 999px; font-size: 12px; font-weight: 700; }
.hm-pager { display: flex; justify-content: center; align-items: center; gap: 14px; margin-top: 16px; font-size: 14px; }
.hm-card { background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; padding: 20px; margin-bottom: 16px; }
.hm-card.has-err { border-color: #fca5a5; }
.hm-card h3 { margin: 0 0 14px; font-size: 16px; }
.hm-card h3 small { font-weight: 400; color: #6b7280; font-size: 12px; }
.hm-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(230px, 1fr)); gap: 14px; margin-bottom: 4px; }
.hm-grid2 { display: grid; grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); gap: 16px; margin-bottom: 16px; }
.hm-grid2 .hm-card { margin-bottom: 0; }
.hm-field { margin-bottom: 10px; }
.hm-field label { display: block; font-size: 13px; font-weight: 600; margin-bottom: 6px; color: #374151; }
.hm-field label i { color: #dc2626; font-style: normal; margin-left: 3px; }
.hm-field.has-err .hm-input { border-color: #ef4444; }
.hm-err { display: block; color: #dc2626; font-size: 12px; margin-top: 4px; }
.hm-amen { display: grid; grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); gap: 10px; }
.hm-amen label { display: flex; align-items: center; gap: 8px; padding: 10px 12px; border: 1px solid #e5e7eb; border-radius: 8px; cursor: pointer; font-size: 14px; }
.hm-amen label.on { background: #eff6ff; border-color: #2563eb; color: #1d4ed8; }
.hm-drop { display: flex; flex-direction: column; align-items: center; gap: 4px; padding: 26px; border: 2px dashed #cbd5e1; border-radius: 12px; cursor: pointer; color: #475569; background: #f8fafc; text-align: center; margin: 10px 0; }
.hm-drop:hover { border-color: #2563eb; background: #eff6ff; }
.hm-drop.small { padding: 16px; }
.hm-drop span { font-size: 12px; color: #94a3b8; }
.hm-sub { font-size: 13px; color: #6b7280; margin: 8px 0; }
.hm-media-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(140px, 1fr)); gap: 12px; margin-top: 10px; }
.hm-media { position: relative; border-radius: 10px; overflow: hidden; border: 1px solid #e5e7eb; background: #f3f4f6; }
.hm-media img, .hm-media video { width: 100%; height: 110px; object-fit: cover; display: block; }
.hm-media button { width: 100%; border: 0; background: #fee2e2; color: #991b1b; padding: 6px; cursor: pointer; font-weight: 600; font-size: 12px; }
.hm-docs { display: flex; flex-wrap: wrap; gap: 8px; }
.hm-doc { display: inline-flex; align-items: center; gap: 8px; padding: 7px 12px; background: #f3f4f6; border-radius: 8px; font-size: 13px; color: #2563eb; text-decoration: none; }
.hm-doc a { color: #2563eb; text-decoration: none; }
.hm-doc button { border: 0; background: none; color: #b91c1c; cursor: pointer; font-size: 16px; line-height: 1; }
.hm-submit-bar { position: sticky; bottom: 0; display: flex; justify-content: flex-end; gap: 10px; padding: 14px 0; background: linear-gradient(to top, #fff 70%, rgba(255,255,255,0)); }
.hm-hero { border-radius: 12px; overflow: hidden; background: #000; max-height: 420px; display: flex; justify-content: center; }
.hm-hero img, .hm-hero video { max-width: 100%; max-height: 420px; object-fit: contain; }
.hm-strip { display: flex; gap: 8px; margin-top: 10px; overflow-x: auto; padding-bottom: 4px; }
.hm-strip button { border: 2px solid transparent; padding: 0; border-radius: 8px; overflow: hidden; cursor: pointer; flex: 0 0 auto; background: none; }
.hm-strip button.on { border-color: #2563eb; }
.hm-strip img, .hm-strip video { width: 90px; height: 64px; object-fit: cover; display: block; }
.hm-row { display: flex; justify-content: space-between; gap: 12px; padding: 9px 0; border-bottom: 1px solid #f1f5f9; font-size: 14px; }
.hm-row:last-child { border-bottom: 0; }
.hm-row span { color: #6b7280; }
.hm-row b { text-align: right; font-weight: 600; }
.hm-desc { white-space: pre-wrap; line-height: 1.6; margin: 0; }
.hm-chips { display: flex; flex-wrap: wrap; gap: 8px; }
.hm-chip { background: #eff6ff; color: #1d4ed8; padding: 6px 12px; border-radius: 999px; font-size: 13px; font-weight: 600; }

.hm-steps { list-style: none; display: flex; gap: 6px; padding: 0; margin: 0 0 18px; overflow-x: auto; }
.hm-steps li { flex: 1 0 auto; }
.hm-steps button { width: 100%; display: flex; align-items: center; gap: 8px; padding: 10px 12px; border: 1px solid #e5e7eb; border-radius: 10px; background: #fff; color: #6b7280; font-size: 13px; font-weight: 600; cursor: pointer; white-space: nowrap; }
.hm-steps button:disabled { cursor: default; }
.hm-steps button span { display: inline-grid; place-items: center; width: 22px; height: 22px; border-radius: 50%; background: #f3f4f6; font-size: 12px; }
.hm-steps li.on button { border-color: #2563eb; color: #1d4ed8; background: #eff6ff; }
.hm-steps li.on button span { background: #2563eb; color: #fff; }
.hm-steps li.done button { color: #065f46; }
.hm-steps li.done button span { background: #d1fae5; color: #065f46; }
.hm-steps button:focus-visible, .hm-btn:focus-visible, .hm-link:focus-visible { outline: 2px solid #2563eb; outline-offset: 2px; }

.hm-confirm { align-items: center; }
.hm-confirm span { font-size: 13px; color: #991b1b; font-weight: 600; }

.hm-badge.hm-active { background: #d1fae5; color: #065f46; }
.hm-badge.hm-inactive { background: #e5e7eb; color: #374151; }

.hm-check { display: flex; align-items: center; gap: 8px; font-size: 14px; margin-top: 8px; cursor: pointer; }
.hm-review-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 16px; }

@media (max-width: 640px) {
  .hm-submit-bar { flex-wrap: wrap; }
  .hm-submit-bar .hm-btn { flex: 1; }
}
`;

/* ============ CONFIG ============ */
// Backend default port is 7000. Set REACT_APP_API_URL in .env (e.g. https://bmtvendorvendorfinal.onrender.com)
// and restart the React dev server after changing it.
const API_BASE = (process.env.REACT_APP_API_URL || "https://bmtvendorvendorfinal.onrender.com").replace(/\/+$/, "");
const API = `${API_BASE}/api/vendor/hostels`;

const MEDIA_ACCEPT = "image/jpeg,image/png,image/webp,video/mp4,video/webm,video/quicktime";
const MAX_SIZE = 20 * 1024 * 1024;

const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("vendorToken") || ""}` });

async function request(url, options = {}) {
  let res;
  try {
    res = await fetch(url, { ...options, headers: { ...authHeaders(), ...(options.headers || {}) } });
  } catch {
    throw new Error(`Server se connect nahi ho paaya (${API_BASE}). Backend chal raha hai?`);
  }

  let data = {};
  try { data = await res.json(); } catch { /* ignore */ }

  if (res.status === 404 && /route not found/i.test(data.message || "")) {
    throw new Error("Hostel API route backend par mounted nahi hai. Backend terminal mein 'Cannot load ./routes/hostel.routes' wali error check karo.");
  }
  if (!res.ok || data.success === false) throw new Error(data.message || `Request failed (${res.status})`);
  return data;
}

const money = (n) => `₹ ${Number(n || 0).toLocaleString("en-IN")}`;
const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "-";

/* ============ SMALL PIECES ============ */
function ActiveBadge({ active }) {
  return <span className={`hm-badge ${active ? "hm-active" : "hm-inactive"}`}>{active ? "Active" : "Inactive"}</span>;
}

function MediaThumb({ item, className = "" }) {
  if (!item) return <div className={`hm-noimg ${className}`}>No media</div>;
  if (item.resourceType === "video") return <video className={className} src={item.url} muted />;
  return <img className={className} src={item.url} alt={item.originalName || "media"} />;
}

function Row({ k, v }) {
  return (
    <div className="hm-row">
      <span>{k}</span>
      <b>{v === undefined || v === null || v === "" ? "-" : v}</b>
    </div>
  );
}

/* Defined at module level on purpose: components declared inside another component
   get re-created on every keystroke and the input loses focus. */
function Field({ label, name, value, onChange, error, required, ...rest }) {
  return (
    <div className={`hm-field ${error ? "has-err" : ""}`}>
      <label htmlFor={name}>{label}{required && <i>*</i>}</label>
      <input id={name} className="hm-input" value={value} onChange={(e) => onChange(name, e.target.value)} {...rest} />
      {error && <small className="hm-err">{error}</small>}
    </div>
  );
}

function SelectField({ label, name, value, onChange, options, error, disabled }) {
  return (
    <div className={`hm-field ${error ? "has-err" : ""}`}>
      <label htmlFor={name}>{label}</label>
      <select id={name} className="hm-input" value={value} disabled={disabled} onChange={(e) => onChange(name, e.target.value)}>
        {options.map((o) => (typeof o === "string" ? <option key={o}>{o}</option> : <option key={o.value} value={o.value}>{o.label}</option>))}
      </select>
      {error && <small className="hm-err">{error}</small>}
    </div>
  );
}

/* ============ WIZARD ============ */
function Stepper({ steps, current, onJump }) {
  return (
    <ol className="hm-steps">
      {steps.map((s, i) => (
        <li key={s} className={i === current ? "on" : i < current ? "done" : ""}>
          <button type="button" disabled={i > current} onClick={() => onJump(i)}>
            <span>{i < current ? "✓" : i + 1}</span>{s}
          </button>
        </li>
      ))}
    </ol>
  );
}

function WizardBar({ step, last, saving, onBack, onCancel, submitLabel }) {
  return (
    <div className="hm-submit-bar">
      <button type="button" className="hm-btn" onClick={onCancel} disabled={saving}>Cancel</button>
      {step > 0 && <button type="button" className="hm-btn" onClick={onBack} disabled={saving}>Back</button>}
      <button type="submit" className="hm-btn primary" disabled={saving}>
        {saving ? "Saving..." : step < last ? "Next" : submitLabel}
      </button>
    </div>
  );
}

/* Delete buttons confirm inline in the row (no browser popup) */
function RowActions({ id, busyId, confirmId, setConfirmId, onView, onEdit, onDelete }) {
  if (confirmId === id) {
    return (
      <div className="hm-actions hm-confirm">
        <span>Delete this?</span>
        <button className="hm-btn sm danger" disabled={busyId === id} onClick={onDelete}>{busyId === id ? "..." : "Yes, delete"}</button>
        <button className="hm-btn sm" onClick={() => setConfirmId("")}>Keep</button>
      </div>
    );
  }
  return (
    <div className="hm-actions">
      <button className="hm-btn sm" onClick={onView}>View</button>
      <button className="hm-btn sm" onClick={onEdit}>Edit</button>
      <button className="hm-btn sm danger" onClick={() => setConfirmId(id)}>Delete</button>
    </div>
  );
}

/* ============ FILE PICKER STATE ============ */
function useFileList(limit, label, flash) {
  const [items, setItems] = useState([]); // {file,url}
  const ref = useRef([]);
  ref.current = items;

  useEffect(() => () => ref.current.forEach((i) => URL.revokeObjectURL(i.url)), []);

  const add = (e, existingCount = 0) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    const ok = [];
    for (const f of files) {
      if (f.size > MAX_SIZE) { flash("error", `${f.name} is larger than 20 MB.`); continue; }
      ok.push({ file: f, url: URL.createObjectURL(f) });
    }
    if (existingCount + items.length + ok.length > limit) {
      ok.forEach((o) => URL.revokeObjectURL(o.url));
      flash("error", `You can add at most ${limit} ${label}.`);
      return;
    }
    setItems((p) => [...p, ...ok]);
  };

  const remove = (idx) => {
    URL.revokeObjectURL(items[idx].url);
    setItems((p) => p.filter((_, i) => i !== idx));
  };

  return { items, add, remove };
}

function useFlash() {
  const [notice, setNotice] = useState(null);
  const timer = useRef();
  const flash = (type, text) => {
    setNotice({ type, text });
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setNotice(null), 5000);
  };
  useEffect(() => () => clearTimeout(timer.current), []);
  return [notice, flash];
}

/* ============ CONSTANTS ============ */
const HOSTEL_TYPES = [
  "Co-Living Hostel", "Student Hostel", "Backpacker Hostel", "Working Professionals Hostel",
  "Girls Hostel", "Boys Hostel", "Mixed Dormitory Hostel", "Other",
];
const GENDERS = ["Unisex", "Male", "Female"];
const POLICIES = ["Flexible", "Moderate", "Strict", "Non-refundable"];
const AMENITIES = [
  "Wi-Fi", "AC", "Attached Bathroom", "Laundry", "Parking", "CCTV", "Power Backup", "Housekeeping",
  "Common Kitchen", "Dining Area", "Study Area", "Locker", "Washing Machine", "Hot Water", "Gym", "Common Lounge",
];
const MAX_IMAGES = 30;
const MAX_DOCS = 10;

const EMPTY_FORM = {
  hostelName: "", hostelType: "Co-Living Hostel", genderPreference: "Unisex", description: "",
  contactName: "", contactPhone: "", contactEmail: "",
  address: "", city: "", state: "", pincode: "", latitude: "", longitude: "",
  checkInTime: "12:00", checkOutTime: "11:00",
  totalRooms: "", totalBeds: "", startingPrice: "", securityDeposit: "0",
  cancellationPolicy: "Flexible", amenities: [], isActive: true,
};

const STEPS = ["Basics", "Location", "Rooms & pricing", "Amenities", "Photos & documents", "Review"];
// which fields belong to which step (used for per-step validation)
const STEP_KEYS = [
  ["hostelName", "description", "contactEmail", "contactPhone"],
  ["address", "city", "state", "pincode", "latitude", "longitude"],
  ["totalRooms", "totalBeds", "startingPrice", "securityDeposit"],
  [],
  ["images"],
  [],
];

/* ============ MAIN ============ */
export default function HostelManager() {
  const [view, setView] = useState("list"); // list | add | edit | view
  const [selected, setSelected] = useState(null);
  const [notice, flash] = useFlash();

  const go = (v, hostel = null) => {
    setSelected(hostel);
    setView(v);
    window.scrollTo?.({ top: 0 });
  };

  return (
    <div className="hm-page">
      <style>{CSS}</style>
      {notice && <div className={`hm-notice ${notice.type}`} role="status">{notice.text}</div>}

      {view === "list" && <HostelList go={go} flash={flash} />}
      {view === "view" && selected && <HostelView hostel={selected} go={go} />}
      {(view === "add" || view === "edit") && (
        <HostelForm
          key={selected?._id || "new"}
          hostel={view === "edit" ? selected : null}
          onCancel={() => go("list")}
          onSaved={(msg) => { flash("success", msg); go("list"); }}
          flash={flash}
        />
      )}
    </div>
  );
}

/* ============ LIST ============ */
function HostelList({ go, flash }) {
  const [hostels, setHostels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [activeFilter, setActiveFilter] = useState(""); // "" | active | inactive (client-side)
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [busyId, setBusyId] = useState("");
  const [confirmId, setConfirmId] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const qs = new URLSearchParams({ page, limit: 10 });
      const data = await request(`${API}?${qs.toString()}`);
      setHostels(data.hostels || []);
      setTotalPages(data.totalPages || 1);
      setTotal(data.total || 0);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [page]);

  useEffect(() => { load(); }, [load]);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    return hostels.filter((h) => {
      if (activeFilter === "active" && !h.isActive) return false;
      if (activeFilter === "inactive" && h.isActive) return false;
      if (!q) return true;
      return [h.hostelName, h.city, h.state, h.hostelType].join(" ").toLowerCase().includes(q);
    });
  }, [hostels, search, activeFilter]);

  const open = async (h, target) => {
    try {
      const data = await request(`${API}/${h._id}`);
      go(target, data.hostel);
    } catch (e) { flash("error", e.message); }
  };

  const remove = async (h) => {
    setBusyId(h._id);
    try {
      await request(`${API}/${h._id}`, { method: "DELETE" });
      flash("success", "Hostel deleted.");
      setConfirmId("");
      if (hostels.length === 1 && page > 1) setPage(page - 1);
      else load();
    } catch (e) { flash("error", e.message); }
    finally { setBusyId(""); }
  };

  return (
    <>
      <div className="hm-head">
        <div>
          <span className="hm-eyebrow">HOSTEL PARTNER</span>
          <h2>My Hostels</h2>
          <p>Add, view, edit and delete your hostels. Total: {total}</p>
        </div>
        <button className="hm-btn primary" onClick={() => go("add")}>+ Add Hostel</button>
      </div>

      <div className="hm-toolbar">
        <input className="hm-input" placeholder="Search by name, city or type" value={search} onChange={(e) => setSearch(e.target.value)} />
        <select className="hm-input" value={activeFilter} onChange={(e) => setActiveFilter(e.target.value)}>
          <option value="">All listings</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
        <button className="hm-btn" onClick={load}>Refresh</button>
      </div>

      {loading && <div className="hm-state">Loading hostels...</div>}
      {!loading && error && <div className="hm-state err">{error} <button className="hm-btn" onClick={load}>Retry</button></div>}

      {!loading && !error && filtered.length === 0 && (
        <div className="hm-state">
          <div className="hm-empty-icon">⌂</div>
          <h3>No hostels found</h3>
          <p>{hostels.length ? "Koi hostel filter se match nahi hua." : "Add your first hostel to start listing."}</p>
          {!hostels.length && <button className="hm-btn primary" onClick={() => go("add")}>+ Add Hostel</button>}
        </div>
      )}

      {!loading && !error && filtered.length > 0 && (
        <div className="hm-table-wrap">
          <table className="hm-table">
            <thead>
              <tr>
                <th>Hostel</th><th>Location</th><th>Type</th><th>Rooms / Beds</th>
                <th>Starting price</th><th>Status</th><th>Created</th><th className="r">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((h) => (
                <tr key={h._id}>
                  <td>
                    <div className="hm-cell-main">
                      <MediaThumb item={h.images?.[0]} className="hm-thumb" />
                      <div>
                        <strong>{h.hostelName}</strong>
                        <small>{h.genderPreference}</small>
                      </div>
                    </div>
                  </td>
                  <td>{h.city}, {h.state}</td>
                  <td>{h.hostelType}</td>
                  <td>{h.totalRooms} / {h.totalBeds}</td>
                  <td>{money(h.startingPrice)}</td>
                  <td><ActiveBadge active={h.isActive} /></td>
                  <td>{fmtDate(h.createdAt)}</td>
                  <td className="r">
                    <RowActions
                      id={h._id} busyId={busyId} confirmId={confirmId} setConfirmId={setConfirmId}
                      onView={() => open(h, "view")} onEdit={() => open(h, "edit")} onDelete={() => remove(h)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {totalPages > 1 && (
        <div className="hm-pager">
          <button className="hm-btn sm" disabled={page <= 1} onClick={() => setPage(page - 1)}>‹ Prev</button>
          <span>Page {page} / {totalPages}</span>
          <button className="hm-btn sm" disabled={page >= totalPages} onClick={() => setPage(page + 1)}>Next ›</button>
        </div>
      )}
    </>
  );
}

/* ============ VIEW ============ */
function HostelView({ hostel: h, go }) {
  const [active, setActive] = useState(0);
  const media = h.images || [];
  const current = media[active];

  return (
    <>
      <div className="hm-head">
        <div>
          <button className="hm-link" onClick={() => go("list")}>← Back to list</button>
          <h2>{h.hostelName} <ActiveBadge active={h.isActive} /></h2>
          <p>{h.address}, {h.city}, {h.state} - {h.pincode}</p>
        </div>
        <button className="hm-btn primary" onClick={() => go("edit", h)}>Edit Hostel</button>
      </div>

      <div className="hm-card">
        <h3>Photos & videos ({media.length})</h3>
        {media.length === 0 ? <p>No media uploaded.</p> : (
          <>
            <div className="hm-hero">
              {current?.resourceType === "video" ? <video src={current.url} controls /> : <img src={current?.url} alt={h.hostelName} />}
            </div>
            <div className="hm-strip">
              {media.map((m, i) => (
                <button type="button" key={m._id || m.publicId} className={i === active ? "on" : ""} onClick={() => setActive(i)}>
                  <MediaThumb item={m} />
                </button>
              ))}
            </div>
          </>
        )}
      </div>

      <div className="hm-grid2">
        <div className="hm-card">
          <h3>Basic information</h3>
          <Row k="Hostel type" v={h.hostelType} />
          <Row k="Gender preference" v={h.genderPreference} />
          <Row k="Total rooms" v={h.totalRooms} />
          <Row k="Total beds" v={h.totalBeds} />
          <Row k="Check-in" v={h.checkInTime} />
          <Row k="Check-out" v={h.checkOutTime} />
          <Row k="Listing" v={h.isActive ? "Active" : "Inactive"} />
          <Row k="Created" v={fmtDate(h.createdAt)} />
          <Row k="Last updated" v={fmtDate(h.updatedAt)} />
        </div>
        <div className="hm-card">
          <h3>Pricing & policy</h3>
          <Row k="Starting price" v={money(h.startingPrice)} />
          <Row k="Security deposit" v={money(h.securityDeposit)} />
          <Row k="Cancellation policy" v={h.cancellationPolicy} />
          <h3 style={{ marginTop: 18 }}>Contact</h3>
          <Row k="Name" v={h.contactName} />
          <Row k="Phone" v={h.contactPhone} />
          <Row k="Email" v={h.contactEmail} />
          <Row k="Latitude" v={h.latitude} />
          <Row k="Longitude" v={h.longitude} />
        </div>
      </div>

      <div className="hm-card"><h3>Description</h3><p className="hm-desc">{h.description}</p></div>

      <div className="hm-card">
        <h3>Amenities</h3>
        {h.amenities?.length
          ? <div className="hm-chips">{h.amenities.map((a) => <span key={a} className="hm-chip">{a}</span>)}</div>
          : <p>No amenities selected.</p>}
      </div>

      <div className="hm-card">
        <h3>Documents ({h.documents?.length || 0})</h3>
        {h.documents?.length ? (
          <div className="hm-docs">
            {h.documents.map((d) => (
              <a key={d._id || d.publicId} href={d.url} target="_blank" rel="noreferrer" className="hm-doc">{d.originalName || "Document"} ↗</a>
            ))}
          </div>
        ) : <p>No documents uploaded.</p>}
      </div>
    </>
  );
}

/* ============ ADD / EDIT WIZARD ============ */
function HostelForm({ hostel, onCancel, onSaved, flash }) {
  const isEdit = Boolean(hostel);

  const [step, setStep] = useState(0);
  const [form, setForm] = useState(() =>
    hostel
      ? {
          ...EMPTY_FORM,
          ...Object.fromEntries(Object.keys(EMPTY_FORM).map((k) => [k, hostel[k] ?? EMPTY_FORM[k]])),
          amenities: hostel.amenities || [],
          isActive: hostel.isActive !== false,
        }
      : EMPTY_FORM
  );
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const images = useFileList(MAX_IMAGES, "images/videos", flash);
  const docs = useFileList(MAX_DOCS, "documents", flash);
  const [removeImageIds, setRemoveImageIds] = useState([]);
  const [removeDocIds, setRemoveDocIds] = useState([]);

  const existingImages = (hostel?.images || []).filter((i) => !removeImageIds.includes(i.publicId));
  const existingDocs = (hostel?.documents || []).filter((d) => !removeDocIds.includes(d.publicId));

  const set = (k, v) => {
    setForm((p) => ({ ...p, [k]: v }));
    if (errors[k]) setErrors((p) => ({ ...p, [k]: "" }));
  };
  const toggleAmenity = (a) =>
    set("amenities", form.amenities.includes(a) ? form.amenities.filter((x) => x !== a) : [...form.amenities, a]);

  const validateAll = () => {
    const e = {};
    ["hostelName", "description", "address", "city", "state", "pincode", "totalRooms", "totalBeds", "startingPrice"].forEach((k) => {
      if (String(form[k] ?? "").trim() === "") e[k] = "Required";
    });
    if (form.pincode && !/^\d{6}$/.test(String(form.pincode))) e.pincode = "Enter a 6-digit pincode";
    if (form.contactEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.contactEmail)) e.contactEmail = "Enter a valid email";
    if (form.contactPhone) {
      const d = String(form.contactPhone).replace(/\D/g, "");
      if (d.length < 10 || d.length > 15) e.contactPhone = "Enter a valid phone number";
    }
    ["totalRooms", "totalBeds"].forEach((k) => {
      if (form[k] !== "" && (!Number.isInteger(Number(form[k])) || Number(form[k]) < 1)) e[k] = "Whole number, 1 or more";
    });
    if (form.startingPrice !== "" && Number(form.startingPrice) < 1) e.startingPrice = "Minimum 1";
    if (form.securityDeposit !== "" && Number(form.securityDeposit) < 0) e.securityDeposit = "Cannot be negative";
    if (form.latitude !== "" && (Number(form.latitude) < -90 || Number(form.latitude) > 90)) e.latitude = "Between -90 and 90";
    if (form.longitude !== "" && (Number(form.longitude) < -180 || Number(form.longitude) > 180)) e.longitude = "Between -180 and 180";
    if (existingImages.length + images.items.length < 1) e.images = "Add at least one photo or video";
    return e;
  };

  const submit = async () => {
    setSaving(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => {
        if (k === "amenities") fd.append(k, JSON.stringify(v));
        else if (k === "isActive") fd.append(k, v ? "true" : "false");
        else fd.append(k, v === null || v === undefined ? "" : String(v).trim());
      });
      images.items.forEach((i) => fd.append("images", i.file));
      docs.items.forEach((i) => fd.append("documents", i.file));
      if (isEdit) {
        fd.append("removeImagePublicIds", JSON.stringify(removeImageIds));
        fd.append("removeDocumentPublicIds", JSON.stringify(removeDocIds));
      }
      const data = await request(isEdit ? `${API}/${hostel._id}` : API, { method: isEdit ? "PUT" : "POST", body: fd });
      onSaved(data.message || "Saved.");
    } catch (e) {
      flash("error", e.message);
    } finally {
      setSaving(false);
    }
  };

  // Enter key / Next button: validate the current step, then move on. Last step submits.
  const onSubmit = (ev) => {
    ev.preventDefault();
    const all = validateAll();
    const last = STEPS.length - 1;

    if (step < last) {
      const mine = Object.fromEntries(Object.entries(all).filter(([k]) => STEP_KEYS[step].includes(k)));
      if (Object.keys(mine).length) { setErrors(mine); flash("error", "Please fix the highlighted fields."); return; }
      setErrors({});
      setStep(step + 1);
      window.scrollTo?.({ top: 0 });
      return;
    }

    if (Object.keys(all).length) {
      setErrors(all);
      const bad = STEP_KEYS.findIndex((keys) => keys.some((k) => all[k]));
      if (bad >= 0) setStep(bad);
      flash("error", "Some steps have errors. Please fix them.");
      return;
    }
    submit();
  };

  const fp = (name, label, extra = {}) => (
    <Field label={label} name={name} value={form[name]} onChange={set} error={errors[name]} {...extra} />
  );

  return (
    <form onSubmit={onSubmit} noValidate>
      <div className="hm-head">
        <div>
          <button type="button" className="hm-link" onClick={onCancel}>← Back to list</button>
          <h2>{isEdit ? `Edit: ${hostel.hostelName}` : "Add new hostel"}</h2>
          <p>{isEdit ? "Save karte hi changes live ho jayenge." : "Submit karte hi hostel live ho jayega."}</p>
        </div>
      </div>

      <Stepper steps={STEPS} current={step} onJump={setStep} />

      {step === 0 && (
        <div className="hm-card">
          <h3>Basics</h3>
          <div className="hm-grid">
            {fp("hostelName", "Hostel name", { required: true, maxLength: 150, placeholder: "e.g. Zostel Rishikesh" })}
            <SelectField label="Hostel type" name="hostelType" value={form.hostelType} onChange={set} options={HOSTEL_TYPES} />
            <SelectField label="Gender preference" name="genderPreference" value={form.genderPreference} onChange={set} options={GENDERS} />
          </div>
          <div className={`hm-field ${errors.description ? "has-err" : ""}`}>
            <label htmlFor="description">Description<i>*</i></label>
            <textarea id="description" className="hm-input" rows={5} maxLength={10000} value={form.description}
              onChange={(e) => set("description", e.target.value)} placeholder="Tell guests about the hostel" />
            {errors.description && <small className="hm-err">{errors.description}</small>}
          </div>
          <label className="hm-check">
            <input type="checkbox" checked={form.isActive} onChange={(e) => set("isActive", e.target.checked)} />
            Listing active (guests ko dikhega)
          </label>
          <h3 style={{ marginTop: 18 }}>Contact</h3>
          <div className="hm-grid">
            {fp("contactName", "Contact name")}
            {fp("contactPhone", "Contact phone", { placeholder: "+91..." })}
            {fp("contactEmail", "Contact email", { type: "email" })}
          </div>
        </div>
      )}

      {step === 1 && (
        <div className="hm-card">
          <h3>Location</h3>
          <div className="hm-grid">
            {fp("address", "Address", { required: true })}
            {fp("city", "City", { required: true })}
            {fp("state", "State", { required: true })}
            {fp("pincode", "Pincode", { required: true, maxLength: 6, inputMode: "numeric" })}
            {fp("latitude", "Latitude", { type: "number", step: "any", placeholder: "e.g. 30.0869" })}
            {fp("longitude", "Longitude", { type: "number", step: "any", placeholder: "e.g. 78.2676" })}
          </div>
        </div>
      )}

      {step === 2 && (
        <>
          <div className="hm-card">
            <h3>Rooms, beds & timing</h3>
            <div className="hm-grid">
              {fp("totalRooms", "Total rooms", { type: "number", min: "1", required: true })}
              {fp("totalBeds", "Total beds", { type: "number", min: "1", required: true })}
              {fp("checkInTime", "Check-in time", { type: "time" })}
              {fp("checkOutTime", "Check-out time", { type: "time" })}
            </div>
          </div>
          <div className="hm-card">
            <h3>Pricing & policy</h3>
            <div className="hm-grid">
              {fp("startingPrice", "Starting price (₹ per bed)", { type: "number", min: "1", required: true })}
              {fp("securityDeposit", "Security deposit (₹)", { type: "number", min: "0" })}
              <SelectField label="Cancellation policy" name="cancellationPolicy" value={form.cancellationPolicy} onChange={set} options={POLICIES} />
            </div>
          </div>
        </>
      )}

      {step === 3 && (
        <div className="hm-card">
          <h3>Amenities</h3>
          <div className="hm-amen">
            {AMENITIES.map((a) => (
              <label key={a} className={form.amenities.includes(a) ? "on" : ""}>
                <input type="checkbox" checked={form.amenities.includes(a)} onChange={() => toggleAmenity(a)} />
                {a}
              </label>
            ))}
          </div>
        </div>
      )}

      {step === 4 && (
        <>
          <div className={`hm-card ${errors.images ? "has-err" : ""}`}>
            <h3>Photos & videos <small>(max {MAX_IMAGES}, up to 20 MB each)</small></h3>
            {errors.images && <small className="hm-err">{errors.images}</small>}

            {isEdit && existingImages.length > 0 && (
              <>
                <p className="hm-sub">Current files</p>
                <div className="hm-media-grid">
                  {existingImages.map((m) => (
                    <div className="hm-media" key={m.publicId}>
                      <MediaThumb item={m} />
                      <button type="button" onClick={() => setRemoveImageIds([...removeImageIds, m.publicId])}>Remove</button>
                    </div>
                  ))}
                </div>
              </>
            )}
            {isEdit && removeImageIds.length > 0 && (
              <p className="hm-sub">{removeImageIds.length} file(s) will be removed. <button type="button" className="hm-link" onClick={() => setRemoveImageIds([])}>Undo</button></p>
            )}

            <label className="hm-drop">
              <input type="file" multiple accept={MEDIA_ACCEPT} hidden onChange={(e) => images.add(e, existingImages.length)} />
              <b>＋ Choose photos / videos</b>
              <span>JPG, PNG, WEBP, MP4, WEBM, MOV</span>
            </label>

            {images.items.length > 0 && (
              <div className="hm-media-grid">
                {images.items.map((m, i) => (
                  <div className="hm-media" key={m.url}>
                    {m.file.type.startsWith("video/") ? <video src={m.url} muted /> : <img src={m.url} alt={m.file.name} />}
                    <button type="button" onClick={() => images.remove(i)}>Remove</button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="hm-card">
            <h3>Documents <small>(optional, max {MAX_DOCS}; only image/video files are accepted for now)</small></h3>

            {isEdit && existingDocs.length > 0 && (
              <div className="hm-docs">
                {existingDocs.map((d) => (
                  <span className="hm-doc" key={d.publicId}>
                    <a href={d.url} target="_blank" rel="noreferrer">{d.originalName || "Document"} ↗</a>
                    <button type="button" aria-label="Remove document" onClick={() => setRemoveDocIds([...removeDocIds, d.publicId])}>×</button>
                  </span>
                ))}
              </div>
            )}
            {isEdit && removeDocIds.length > 0 && (
              <p className="hm-sub">{removeDocIds.length} document(s) will be removed. <button type="button" className="hm-link" onClick={() => setRemoveDocIds([])}>Undo</button></p>
            )}

            <label className="hm-drop small">
              <input type="file" multiple accept={MEDIA_ACCEPT} hidden onChange={(e) => docs.add(e, existingDocs.length)} />
              <b>＋ Choose documents</b>
            </label>

            {docs.items.length > 0 && (
              <div className="hm-docs">
                {docs.items.map((d, i) => (
                  <span className="hm-doc" key={d.url}>
                    {d.file.name}
                    <button type="button" aria-label="Remove file" onClick={() => docs.remove(i)}>×</button>
                  </span>
                ))}
              </div>
            )}
          </div>
        </>
      )}

      {step === 5 && (
        <div className="hm-review-grid">
          <div className="hm-card">
            <h3>Basics</h3>
            <Row k="Name" v={form.hostelName} />
            <Row k="Type" v={form.hostelType} />
            <Row k="Gender" v={form.genderPreference} />
            <Row k="Listing" v={form.isActive ? "Active" : "Inactive"} />
            <Row k="Contact" v={[form.contactName, form.contactPhone, form.contactEmail].filter(Boolean).join(", ")} />
            <h3 style={{ marginTop: 18 }}>Location</h3>
            <Row k="Address" v={`${form.address}, ${form.city}, ${form.state} - ${form.pincode}`} />
            <Row k="Coordinates" v={form.latitude !== "" && form.longitude !== "" ? `${form.latitude}, ${form.longitude}` : ""} />
          </div>
          <div className="hm-card">
            <h3>Rooms & pricing</h3>
            <Row k="Rooms / beds" v={`${form.totalRooms} / ${form.totalBeds}`} />
            <Row k="Check-in / out" v={`${form.checkInTime} / ${form.checkOutTime}`} />
            <Row k="Starting price" v={money(form.startingPrice)} />
            <Row k="Security deposit" v={money(form.securityDeposit)} />
            <Row k="Cancellation" v={form.cancellationPolicy} />
            <h3 style={{ marginTop: 18 }}>Content</h3>
            <Row k="Amenities" v={form.amenities.length ? form.amenities.join(", ") : ""} />
            <Row k="Photos / videos" v={existingImages.length + images.items.length} />
            <Row k="Documents" v={existingDocs.length + docs.items.length} />
          </div>
        </div>
      )}

      <WizardBar
        step={step} last={STEPS.length - 1} saving={saving}
        onBack={() => { setStep(step - 1); window.scrollTo?.({ top: 0 }); }}
        onCancel={onCancel}
        submitLabel={isEdit ? "Save changes" : "Submit hostel"}
      />
    </form>
  );
}